export default __webpack_public_path__ + "static/media/favicon.2b0d4a69.webp";